import type { Risk } from "@/admin/catalog/types";

export type { Risk };

export function needsConfirm(risk: Risk): boolean {
  return risk !== "none";
}

const ORDER: Risk[] = ["none", "caution", "danger"];

/** The stricter of two risks. */
export function maxRisk(a: Risk, b: Risk): Risk {
  return ORDER.indexOf(a) >= ORDER.indexOf(b) ? a : b;
}
